import { render, staticRenderFns } from "./CommonQuestionForm.vue?vue&type=template&id=56795051&"
import script from "./CommonQuestionForm.vue?vue&type=script&lang=js&"
export * from "./CommonQuestionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports